import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function ForwardIcon() {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width='45'
      height='46'
      viewBox='0 0 32 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.279297'
        y='0.0166016'
        width='44.978'
        height='44.978'
        rx='2.81113'
      />
      <path
        d='M8.5 22C8.77614 22 9 21.7761 9 21.5V10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5V21.5C8 21.7761 8.22386 22 8.5 22ZM11 16C11 16.2761 11.2239 16.5 11.5 16.5L22.2929 16.5L19.1464 19.6464C18.9512 19.8417 18.9512 20.1583 19.1464 20.3535C19.3417 20.5488 19.6583 20.5488 19.8536 20.3535L23.8536 16.3535C23.9061 16.301 23.9445 16.2397 23.9688 16.1744C23.989 16.1201 24 16.0613 24 16C24 15.9387 23.989 15.8799 23.9687 15.8256C23.9445 15.7603 23.9061 15.699 23.8536 15.6464L19.8536 11.6464C19.6583 11.4512 19.3417 11.4512 19.1464 11.6464C18.9512 11.8417 18.9512 12.1583 19.1464 12.3535L22.2929 15.5L11.5 15.5C11.2239 15.5 11 15.7239 11 16Z'
        fill={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
      />
    </svg>
  )
}
